<div class="pd-content-container">
    <!-- Spinner while catalog is being loaded -->
    <div *ngIf="loading && !loadError" class="pd-loader">
        <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
    </div>

    <!-- Error loading content -->
    <div *ngIf="!loading && loadError" class="pd-permission-error">
        <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
        There was an error loading sources. Click below try again.
        <button hc-button size="lg" (click)="loadSources()">Reload Sources</button>
    </div>

    <div class="product-catalog-table-container" [hidden]="loadError || loading">
        <div class="sources-control-bar">
            <div class="sources-filters">
                <div class="filter-dropdown" title="Filter by product type">
                    <label for="type">Type</label>
                    <button hc-button buttonStyle="link-inline" id="type" [hcPop]="filtermenu"
                        (click)="storeFilterData('type')" [context]="typeFilters">
                        <span class="value hc-text-ellipsis filter-dropdown-length">{{ typeText }}</span>
                        <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                    </button>
                </div>
                <div class="filter-dropdown" title="Filter by status">
                    <label for="status">Status</label>
                    <button hc-button buttonStyle="link-inline" id="status" [hcPop]="filtermenu"
                        (click)="storeFilterData('status')" [context]="statusFilters">
                        <span class="value hc-text-ellipsis filter-dropdown-length">{{ statusText }}</span>
                        <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                    </button>
                </div>

                <hc-pop #filtermenu scrollStrategy="close" (opened)="filterSelections = $event">
                    <filter-popover [filterData]="filterData" [setVals]="filterSelections" (close)="filtermenu.close()"
                        (filterChecked)="storeFilterArray($event)"></filter-popover>
                </hc-pop>
            </div>
            <hc-search-bar #searchbar placeholder="Search sources" (triggerSearch)="applyTextFilter($event)"
                class="sources-search"></hc-search-bar>
        </div>
        <table hc-table [borders]="false" class="sources-table" [dataSource]="dataSource" hcSort>
            <!-- ID Column -->
            <ng-container hcColumnDef="item">
                <th hc-index-cell *hcHeaderCellDef hc-sort-header id="itemHeader">ID</th>
                <td hc-index-cell *hcCellDef="let element">{{ element.item }}</td>
            </ng-container>

            <!-- Name Column -->
            <ng-container hcColumnDef="name">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
                <td hc-cell *hcCellDef="let element">{{element.name }}</td>
            </ng-container>

            <!-- Type Column -->
            <ng-container hcColumnDef="type">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="typeHeader">Type</th>
                <td hc-cell *hcCellDef="let element">
                    <span *ngIf="element.type">{{ element.type }}</span>
                    <span *ngIf="!element.type"> -- </span>
                </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container hcColumnDef="status">
                <th hc-header-cell *hcHeaderCellDef hc-sort-header id="statusHeader">Status</th>
                <td hc-cell *hcCellDef="let element">{{ element.status }}</td>
            </ng-container>

            <tr hc-header-row *hcHeaderRowDef="productsDisplayedColumns"></tr>
            <tr hc-row *hcRowDef="let row; columns: productsDisplayedColumns"></tr>
        </table>
        <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
            <span class="hc-empty-table-block-ico hc-empty-ico"></span>
            <span class="hc-empty-table-block-msg">No sources meet your search criteria.</span>
        </div>
        <hc-pagination [length]="sourcesLength" [pageSize]="sourcesPageSize"
            [hidden]="loadError || loading"></hc-pagination>
    </div>
</div>